<template>
    <div class="table-wrapper" style="padding-top: 20px;">
        <Form ref="formInline" :model="formInline" inline
            :label-width="100" label-position="right">
            <div class="search-right-wrapper">
                <Button type="primary" style="float:left;" icon="ios-exit-outline" @click="handleExport">导出</Button>
                <FormItem label="项目所在地:" style="width:286px;text-align:left;">
                    <Select v-model="areaCode" clearable>
                        <Option v-for="item in dictArea" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <Button style="margin-left: 20px;float:right;" @click="handleReset()">重置</Button>
                <Button style="float: right;" type="primary" @click="getTableData1">搜索</Button>
            </div>
        </Form>
        <Table border :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
            <template slot-scope="{ row, index }" slot="action">
                <Button class="table-btn" type="text" size="small" @click="handleDeal('postWarningDetailProject',row,row.projectWorkerId)" v-if="row.areaName !== '合计'">详情</Button>
            </template>
        </Table>
        <!-- <div class="t-page">
            <Page :total="totalCount" :page-size="pageSize" :current="page"
                @on-change="changePage" @on-page-size-change="pageSizeChange"
                show-elevator show-sizer show-total transfer>
            </Page>
        </div> -->
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                dictArea: [],
                areaCode:'',
                formInline:{
                    startDate:'',
                    endDate:''
                },
                formOutLine1: {
                    startDate:'',
                    endDate:''
                },
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '地区',
                        key: 'areaName',
                        minWidth:80,
                    },
                    {
                        title: '在建项目数',
                        key: 'buildingCount',
                        minWidth:50,
                        sortable: true,
                        align: 'right'
                    },
                    {
                        title: '施工总承包单位的项目经理岗位预警',
                        align: 'center',
                        children: [
                            {
                                title:'未设置项目经理的项目数',
                                key: 'unSetManagerProjectCount',
                                minWidth: 150,
                                sortable: true,
                                align: 'right'
                            },
                            {
                                title:'已设置项目经理的项目数',
                                key: 'yetSetManagerProjectCount',
                                minWidth: 150,
                                sortable: true,
                                align: 'right'
                            },
                        ]
                    },
                    {
                        title: '监理单位的总监理工程师岗位预警',
                        align: 'center',
                        children: [
                            {
                                title:'未设置总监理工程师的项目数',
                                key: 'unSetSupervisorProjectCount',
                                minWidth: 170,
                                sortable: true,
                                align: 'right'
                            },
                            {
                                title:'已设置总监理工程师的项目数',
                                key: 'yetSetSupervisorProjectCount',
                                minWidth: 170,
                                sortable: true,
                                align: 'right'
                            },
                        ]

                    },
                    {
                        title: '操作',
                        slot: 'action',
                        fixed: 'right',
                        align: 'center',
                        width: 100
                    }
                ],
                tableData:[],
                exportData:{
                    size:this.pageSize,
                    current:this.page,
                    areaCode:this.areaCode,
                }
            };
        },
        computed:{
            ...mapState(['area']),
        },
        created(){

        },
        mounted(){
            this.areaCode = this.$route.query.areaCode
            if(this.areaCode) {
                this.getTableData1()
                this.getDictCode()
            }
        },
        watch: {
            // '$route': function (to, from) {
            //     if(to.name==='checking-inList'){
            //         this.getTableData();
            //     }
            // },
            areaCode: function (val) {
                if(!val) {
                    this.areaCode = this.$route.query.areaCode
                }
            },
        },
        methods: {
            getDictCode() {
                this.axios({
                    method: 'get',
                    url: '/dict/area/' + this.areaCode,
                }).then( (response)=> {
                    console.log(response)
                    this.dictArea = response.data.data
                }).catch( ()=> {

                });
            },
            handleReset() {
                this.page = 1
                this.formInline = {
                    startDate:'',
                    endDate:''
                }
                this.areaCode = this.$route.query.areaCode
                this.getTableData()
            },
            timeChange(val) {
                console.log(val)
                this.formInline.startDate = val[0]
                this.formInline.endDate = val[1]
            },
            //导出
            handleExport(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    // size:this.pageSize,
                    // current:this.page,
                    areaCode: this.areaCode,
                };
                this.axios({
                    method: 'post',
                    url:'/keyPosition/export',
                    responseType:'arraybuffer',
                    data: param
                }).then( (response)=> {
                    this.common.download(response, '关键岗位预警.xls','application/vnd.ms-excel');
                });
            },
            /*处理操作*/
            handleDeal(name,row,uuid){
                let routeName = '';
                if(row.haveChildArea){
                    routeName = 'postWarningDetail'
                }else{
                    routeName = 'postWarningDetailProject'
                }
                this.$router.push({
                    name: routeName,
                    query: {
                        projectWorkerId:uuid,
                         areaCode: row.areaCode,
                        areaName:row.areaName
                    }
                });
            },
            /*获取表格数据*/
            getTableData1(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    // size:this.pageSize,
                    // current:this.page,
                    areaCode: this.areaCode,
                };
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/keyPosition/statisticsList',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        // this.totalCount = response.data.data.total
                        this.tableData=response.data.data
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
<style scoped >
    .dataTab .ivu-tabs-bar {
        margin-bottom: 0;
        border-bottom: none;
    }
</style>
